import React from 'react'
import { Schema } from 'models/schema'
import { useGetSchema } from 'utils/hooks/queries/useGetSchema'
import { useSchemaState } from './SchemaContext'
import { useUpdateSchemaContext } from './UpdateSchemaContext'

const INTERNAL_ESTIMATION_COLUMN = 'estimationVPAutoHTHF'

const hasInternalEstimationColumn = (schema?: Schema) =>
  schema?.tableMappings.some((mapping) =>
    Object.prototype.hasOwnProperty.call(mapping.customizations, INTERNAL_ESTIMATION_COLUMN),
  ) ?? false

const SchemaPreferenceMigration = () => {
  const { data: fetchedSchemaAndIntervals } = useGetSchema()
  const { schema } = useSchemaState()
  const { mutateAsync, isPending, requiresSingleSelection } = useUpdateSchemaContext()
  const migratedCompanyKeys = React.useRef(new Set<string>())

  const hasLegacyColumn = hasInternalEstimationColumn(fetchedSchemaAndIntervals?.schema)
  const hasHydratedFetchedSchema =
    fetchedSchemaAndIntervals?.schema.userId === schema.userId &&
    fetchedSchemaAndIntervals?.schema.companyId === schema.companyId
  const hasLegacyColumnInCurrentSchema = hasInternalEstimationColumn(schema)
  const migrationKey = `${schema.userId}:${schema.companyId}`

  React.useEffect(() => {
    if (
      !hasLegacyColumn ||
      !hasHydratedFetchedSchema ||
      hasLegacyColumnInCurrentSchema ||
      requiresSingleSelection ||
      isPending ||
      migratedCompanyKeys.current.has(migrationKey)
    ) {
      return
    }

    migratedCompanyKeys.current.add(migrationKey)
    mutateAsync().catch(() => undefined)
  }, [
    hasHydratedFetchedSchema,
    hasLegacyColumn,
    hasLegacyColumnInCurrentSchema,
    isPending,
    migrationKey,
    mutateAsync,
    requiresSingleSelection,
  ])

  return null
}

export { SchemaPreferenceMigration }
